/* eslint-disable no-alert */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tab } from 'semantic-ui-react'
import firebase from 'firebase/app'

import DriverActions from '../../../reducers/driverReducer'

import Loading from '../../../components/common/loading'
import OrderDetail from '../../../lib/OrderDetailModal'

import CreditModal from './CreditModal'
import DriverProfile from './DriverProfile'
import OrderTab from './OrderTab'
import CreditTab from './CreditTab'
import ActivitiesTab from './ActivitiesTab'

class DriverDetail extends Component {
  state = {
    modalCreditVisible: false,

    gettingDetail: false,
    orderDetails: {},
    modalOrderDetailVisible: false,
    viewOrder: null
  }

  componentDidMount() {
    const { driversLoaded, syncDrivers } = this.props

    if (!driversLoaded) syncDrivers()
  }

  getDetail = order => {
    const { orderDetails } = this.state

    firebase.database().ref(`/orders/${order.key}`).once('value', (snapshot) => {
      this.setState({
        gettingDetail: false,
        orderDetails: {
          ...orderDetails,
          [order.key]: {
            ...snapshot.val(),
            key: order.key
          }
        },
      })
    })
  }

  onViewOrderDetail = order => {
    const { orderDetails } = this.state

    if (orderDetails[order.key]) {
      this.setState({
        gettingDetail: false,
        modalOrderDetailVisible: true,
        viewOrder: {
          orderNumber: order.order_number,
          key: order.key
        }
      })
      return;
    }
    this.setState({
      gettingDetail: true,
      modalOrderDetailVisible: true,
      viewOrder: {
        orderNumber: order.order_number,
        key: order.key
      }
    }, () => {
      this.getDetail(order)
    })
  }

  renderTab() {
    const { match, auth, roles, drivers } = this.props
    const driverUid = match.params.id

    const tabs = [
      {
        menuItem:'Order History',
        render: () => <OrderTab driverUid={driverUid} onViewOrderDetail={this.onViewOrderDetail} />
      },
      {
        menuItem: 'Credit History',
        render: () => (
          <CreditTab
            driverUid={driverUid}
            auth={auth}
            roles={roles}
            driver={drivers[driverUid]}

          />
        )
      },
      {
        menuItem: 'Activities & Performance',
        render: () => <ActivitiesTab driverUid={driverUid} />
      },
    ]

    return (
      <Tab menu={{ secondary: true, pointing: true }} panes={tabs} />
    )
  }

  render() {
    const { driversLoading, auth, match, drivers } = this.props
    const { creditLoading, gettingDetail, modalOrderDetailVisible, orderDetails, viewOrder, modalCreditVisible } = this.state
    const driverUid = match.params.id

    return (
      <div>
        <Loading active={creditLoading || driversLoading} />
        <DriverProfile
          driver={drivers[driverUid]}
          driverUid={driverUid}
          auth={auth}
        />

        {this.renderTab()}

        <CreditModal
          visible={modalCreditVisible}
          driverUid={driverUid}
          auth={auth}
          onClose={() => this.setState({ modalCreditVisible: false })}
        />

        <OrderDetail
          visible={modalOrderDetailVisible}
          onClose={() => this.setState({ modalOrderDetailVisible: false, viewOrder: null })}
          order={viewOrder && viewOrder.key && orderDetails[viewOrder.key]}
          loading={gettingDetail}
        />
      </div>
    )
  }
}

const mapState = ({ auth, drivers, rolePermission }) => ({
  auth: auth.data,
  roles: rolePermission.roles,

  drivers: drivers.drivers,
  driversLoading: drivers.driverLoading,
  driversLoaded: drivers.driverLoaded,
})

const mapDispatch = {
  syncDrivers: DriverActions.syncDrivers,
}

export default connect(mapState, mapDispatch)(DriverDetail)



// WEBPACK FOOTER //
// ./src/containers/drivers/detail/index.js